import Button from '@anm/components/buttons/Button';
import { Component } from 'react';

import WeekSwitcherWrapper from './Wrapper';

export interface WeekSwitcherProps {
  onToDayClick: () => void;
  onSwitchLeft: () => void;
  onSwitchRight: () => void;
}

class WeekSwitcher extends Component<WeekSwitcherProps> {
  render() {
    const { onToDayClick, onSwitchLeft, onSwitchRight } = this.props;
    return (
      <WeekSwitcherWrapper>
        <Button size="large" variant="arrow-left" onClick={onSwitchLeft} />
        <Button size="large" variant="square-gray" onClick={onToDayClick}>
          Today
        </Button>
        <Button size="large" variant="arrow-right" onClick={onSwitchRight} />
      </WeekSwitcherWrapper>
    );
  }
}

export default WeekSwitcher;
